export default {
  FORBID_ATTR: ['data-target'],
  // Custom schemes (vclink, m-files) must mirror SfMarkdownText::ALLOWED_PROTOCOLS
  // (lib/sf_markdown_text.rb) and SF_ALLOWED_PROTOCOLS (app/javascript/src/utils/url-helpers.ts).
  ALLOWED_URI_REGEXP:
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|vclink|m-files):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i, // eslint-disable-line no-useless-escape
}
